import type { ReactNode } from 'react';
import { ImagePathContext, IMAGE_PATHS_BY_FORMAT } from '@dreamteam-monorepo/ui';
import { useTeamCreateTournamentCalendarId } from '@/hooks/useTeamCreateTournamentCalendarId';
import { normalizeCompetitionFormat } from '@/lib/periodLabels';

export const ImagePathProvider = ({ children }: { children: ReactNode }) => {
  const { format } = useTeamCreateTournamentCalendarId();
  // Always provide a config: handing down `null` let the shared components fall
  // back to their own World Cup paths ('teams/shirts', 'country-flags'), which
  // put an unresolved format on knockout artwork.
  const config = IMAGE_PATHS_BY_FORMAT[normalizeCompetitionFormat(format)];

  return <ImagePathContext.Provider value={config}>{children}</ImagePathContext.Provider>;
};
